// src/utils/flowSlugConfig.js

// This maps the "home page URL slug" to the QuestionsEngine
// folder structure: Category / Product / QuestionX.json
//
// Example:
//   /car-insurance-quote/step1
// → Vehicle/CarInsurance/Question1.json
//
// If you add new flows, just extend this object.

export const FLOW_SLUG_CONFIG = {
  // Vehicle
  'car-insurance-quote': {
    category: 'Vehicle',
    product: 'CarInsurance',
  },
  'motor-warranty': {
    category: 'Vehicle',
    product: 'MotorWarranty',
  },
  'dents-and-scratches-quote': {
    category: 'Vehicle',
    product: 'Scratch&DentCover',
  },
  'service-plan-quotes': {
    category: 'Vehicle',
    product: 'ServicePlans',
  },
  'vehicle-tracking-quote': {
    category: 'Vehicle',
    product: 'VehicleTracking',
  },
  'tyre-and-rim-guard': {
    category: 'Vehicle',
    product: 'Tyre&RimCover',
  },
  'motorcycle-insurance-quote': {
    category: 'Vehicle',
    product: 'MotorcycleInsurance',
  },

  // Family
  'funeral-insurance-quote': {
    category: 'Family',
    product: 'FuneralInsurance',
  },
  'life-insurance-quote': {
    category: 'Family',
    product: 'LifeInsurance',
  },
  'pet-insurance-quote': {
    category: 'Family',
    product: 'PetInsurance',
  },
  'travel-insurance': {
    category: 'Family',
    product: 'TravelInsurance',
  },

  // Health
  'medical-aid-quote': {
    category: 'Health',
    product: 'MedicalAid',
  },
  'medical-gap-cover-quote': {
    category: 'Health',
    product: 'GapCover',
  },
  'medical-insurance-quotes': {
    category: 'Health',
    product: 'MedicalInsurance',
  },

  // Home
  'buildings-insurance-quote': {
    category: 'Home',
    product: 'BuildingInsurance',
  },
  // Reuse HomeContentsCover for generic home insurance
  'home-insurance-quote': {
    category: 'Home',
    product: 'HomeContentsCover',
  },
  'online-insurance-quote': {
    category: 'Bundle',
    product: 'CombinedQuotes',
  },

  // Money
  'personal-loans': {
    category: 'Money',
    product: 'PersonalLoans',
  },
  'debt-counselling': {
    category: 'Money',
    product: 'DebtCounselling',
  },
  'debt-consolidation-loans': {
    category: 'Money',
    product: 'DebtConsolidation',
  },

  // Other
  // 'compare-fibre-deals' is the Fibre landing page's own route (used for GTM
  // tagging there); the step flow itself now lives under
  // 'check-fibre-in-your-area' (old step URLs redirect to it, see App.js).
  'compare-fibre-deals': {
    category: 'Other',
    product: 'FibreInternet',
  },
  'check-fibre-in-your-area': {
    category: 'Other',
    product: 'FibreInternet',
  },

  // Business
  'business-insurance-quote': {
    category: 'Business',
    product: 'BusinessInsurance',
  },
  'business-insurance-quote/business-legal-cover': {
    category: 'Business',
    product: 'BusinessLegalCover',
  },
  'business-insurance-quote/professional-liability-insurance-cover': {
    category: 'Business',
    product: 'ProfessionalLiability',
  },
  'employee-benefits-quote': {
    category: 'Business',
    product: 'EmployeeBenefits',
  },
  'business-insurance-quote/car-and-commercial-property-insurance': {
    category: 'Business',
    product: 'CommercialProperty',
  },
  'business-insurance-quote/event-liability-insurance': {
    category: 'Business',
    product: 'EventLiabilityCover',
  },
};

// Optional helper, if you ever want a safe getter:
export const getFlowConfig = (slug) => FLOW_SLUG_CONFIG[slug] || null;
